<template>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="notifications.length > 0">
        <div class="box-layout-inner">
            <router-link v-if="notification.route" :to="notification.route" v-for="notification in notifications" :key="notification.id" class="acc-alerts" :class="{ 'urgent': true }">
                <i :class="'fa '+notification.icon"></i>
                <span class="title" v-html="notification.description"></span>

                <i class="fa fa-chevron-right"></i>
            </router-link>
            <a class="acc-alerts" :key="notification.id" :class="{ 'urgent': true }" v-else>
                <i :class="'fa '+notification.icon"></i>
                <span class="title" v-html="notification.description"></span>

                <i class="fa fa-chevron-right"></i>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['show'],
        data () {
            return {
                notifications: [],
            }
        },
        methods: {
            refresh: function () {

                /**
                 * Checking if the user has any notifications
                 **/
                 if(this.$root.auth.user_id) {
                    axios.get('/camp-booking/users/'+this.$root.auth.user_id+'/notifications')
                        .then(response => {
                            response.data.data.forEach(notification => {
                                if(!this.show.includes(notification.type) && !this.show.includes('all'))
                                    return false;

                                var route = { name: "account.overview" };
                                var icon = "fa-exclamation-triangle";
                                var urgent = false;
                                switch(notification.type) {
                                    case 'participant':
                                        route = { name: 'account.children.update', params: { id: notification.id } };
                                        icon = "fa-child";
                                        urgent = true;
                                        break;
                                    case 'marketing':
                                        route = null;
                                        icon = "fa-info-circle";
                                        urgent = false;
                                        break;
                                    case 'booking':
                                        route = { name: 'account.bookings.view', params: { bookingId: notification.id } };
                                }
                                this.notifications.push({
                                    description: notification.description,
                                    id: notification.id,
                                    type: notification.type,
                                    route,
                                    icon,
                                    urgent
                                })

                            })
                        })
                    }
            }
        },
        created () {
            this.refresh();
        }
    }
</script>



// WEBPACK FOOTER //
// Notifications.vue?72e4a9fc